/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Gd } from './Gd';

class GoodsCat extends Gd {
    constructor() {
        super();
        this.baseUrl += '/goodsCat';
    }

    data({ pId, name, isAvailable, schoolOrgId } = {}) {
        return super.get('/data', {
            pId,
            name,
            isAvailable,
            schoolOrgId,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, parentId, name, orderNum, isAvailable, schoolOrgId } = {}) {
        return super.post('/save', {
            id,
            parentId,
            name,
            orderNum,
            isAvailable,
            schoolOrgId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    exists({ id, pId, name, schoolOrgId } = {}) {
        return super.get('/exists', {
            id,
            pId,
            name,
            schoolOrgId,
        });
    }

    select({ pId, name, schoolOrgId } = {}, config) {
        return super.get(
            '/select',
            {
                pId,
                name,
                schoolOrgId,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }

    loadSelectNode({ id, schoolOrgId } = {}, config) {
        return super.get(
            '/loadSelectNode',
            {
                id,
                schoolOrgId,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }
}

export default new GoodsCat();
export { GoodsCat };
